import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component, Ref } from 'vue-property-decorator';
import { iconAccept } from '@/config/dic';
import { formatProtocol } from '@/utils/index';
import { validateor } from '@/utils/validate';
import apis from '@/apis/personal';
import UploadConfig from '@/class/upload.config';
import BreadcrumbHeader from '@/views/Layout/BreadcrumbHeader.vue';
import PasswordReset from '@/components/PasswordReset.vue';
import ApproveDialog from './components/approveDialog.vue';
var uploadConfigIns = new UploadConfig(); // 注册beforeRouteLeave事件

Component.registerHooks(['beforeRouteEnter']);

var PersonInfo = /*#__PURE__*/function (_Vue) {
  _inherits(PersonInfo, _Vue);

  var _super = _createSuper(PersonInfo);

  function PersonInfo() {
    var _this;

    _classCallCheck(this, PersonInfo);

    _this = _super.call(this);
    _this.userIcon = require('@/assets/images/index/user-photo-big.png');
    _this.provinceCode = '100000';
    _this.city = '';
    _this.province = ''; // 是否在更新姓名

    _this.isChangeName = false; // 名称输入框是否自动聚焦

    _this.isNameFocus = false; // 是否在更新邮箱

    _this.isChangeEmail = false; // 邮箱输入框是否自动聚焦

    _this.isEmailFocus = true; // 是否在更新地址

    _this.isChangeAddress = false;
    _this.rules = {
      email: validateor({
        type: 'email'
      }),
      reallyName: validateor({
        type: 'name',
        maxLength: 32
      }),
      address: validateor({
        type: 'common',
        maxLength: 32
      })
    };
    _this.userForm = {
      id: '',
      userName: '',
      nickName: '',
      phoneNo: '',
      phoneCheck: '',
      status: '',
      type: '',
      userDepartmentId: '',
      departmentName: '',
      productCode: '',
      projectId: '',
      userIcon: '',
      createTime: '',
      updateTime: '',
      email: '',
      reallyName: '',
      address: '',
      modelVal: '',
      parentTree: '',
      idCard: '',
      roleIds: '',
      roleName: '',
      createrName: '',
      province: '',
      city: '',
      provinceName: '',
      cityName: '',
      county: '',
      countyName: ''
    };
    _this.pwdDialogVisible = false;
    _this.loading = true;
    _this.loadingIcon = false;
    _this.accept = iconAccept;
    _this.countyList = [];
    _this.cityList = [];
    _this.provinceList = [];
    _this.file = null;
    return _this;
  }

  _createClass(PersonInfo, [{
    key: "changeReallyName",
    // 点击修改姓名
    value: function changeReallyName() {
      this.isChangeName = true; // (this.$refs.reallyNameInput as any).focus()
    } // 点击修改邮箱

  }, {
    key: "changeEmail",
    value: function changeEmail() {
      this.isEmailFocus = true;
      this.isChangeEmail = true;
    } // 点击修改联系地址

  }, {
    key: "changeAddress",
    value: function changeAddress() {
      this.isChangeAddress = true;
      this.getProvinceList();
      this.getCityList(this.userForm.province);
      this.getCountyList(this.userForm.city);
    } // 认证成功回调

  }, {
    key: "approveSuccess",
    value: function approveSuccess() {
      this.getUserInfo();
    } // 修改密码

  }, {
    key: "updatePwd",
    value: function updatePwd() {
      this.pwdDialogVisible = true;
    }
  }, {
    key: "closeDialog",
    value: function closeDialog() {
      this.pwdDialogVisible = false;
    }
  }, {
    key: "doApprove",
    value: function doApprove(type) {
      this.approveDialog.toCheckPhoneNo(type);
    }
  }, {
    key: "getCountyList",
    value: function getCountyList(key) {
      var _this2 = this;

      // 获取区域列表
      if (!key) {
        return;
      } // 用于标志是否置空区域列表


      var flag = false;
      this.userForm.city = key; // 前后两次选中的城市一样时不置空城市列表

      flag = this.city === key;
      this.city = key;
      this.userForm.city = key;
      this.countyList = Object.create(null);
      apis.getGBCode({
        ancestorGbCode: this.userForm.city
      }).then(function (res) {
        _this2.countyList = _this2.formatAncestorGbCode(res.data || [], 'count');
        if (!flag) _this2.userForm.county = '';
      }).catch(function (_) {});
    }
  }, {
    key: "getCityList",
    value: function getCityList(key) {
      var _this3 = this;

      if (!key) {
        return;
      } // 用于标志是否置空城市列表


      var flag = false;
      this.userForm.province = key; // 前后两次选中的省份一样时不置空城市列表

      if (this.province === key) {
        flag = true;
      }

      this.province = key;
      this.cityList = Object.create(null);
      apis.getGBCode({
        ancestorGbCode: this.userForm.province
      }).then(function (res) {
        _this3.cityList = _this3.formatAncestorGbCode(res.data || [], 'city');

        if (!flag) {
          _this3.userForm.city = '';
          _this3.userForm.county = '';
        }
      });
    } // 获取省份列表

  }, {
    key: "getProvinceList",
    value: function () {
      var _getProvinceList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this4 = this;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.provinceList = Object.create(null);
                apis.getGBCode({
                  ancestorGbCode: this.provinceCode
                }).then(function (res) {
                  _this4.provinceList = _this4.formatAncestorGbCode(res.data || [], 'province');
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getProvinceList() {
        return _getProvinceList.apply(this, arguments);
      }

      return getProvinceList;
    }() // 获取人员信息

  }, {
    key: "getUserInfo",
    value: function getUserInfo() {
      var _this5 = this;

      apis.getUserInfo().then(function (res) {
        var _res$data = res.data,
            province = _res$data.province,
            city = _res$data.city;
        _this5.userForm = res.data;
        _this5.userForm.userIcon = formatProtocol(res.data.userIcon);
        _this5.province = province;
        _this5.city = city;
        _this5.loading = false;

        _this5.$store.dispatch('FedSetUserIcon', formatProtocol(res.data.userIcon));

        _this5.$store.dispatch('FedSetUserReallyName', res.data.reallyName || '');
      }).catch(function (_) {
        _this5.$message.error('获取用户信息失败');

        _this5.loading = false;
      });
    }
  }, {
    key: "uploadBefore",
    value: function uploadBefore(file) {
      var result = uploadConfigIns.beforeUpload(file, true);

      if (result) {
        this.loadingIcon = true;
        this.file = file;
      }

      return result;
    } // 人员头像上传成功

  }, {
    key: "uploadSuccess",
    value: function uploadSuccess(response, file, fileList, xhr) {
      this.loadingIcon = false;

      if (!(response && response.data && response.code === '0')) {
        this.$message.error(response.msg);
      } else {
        this.userForm.userIcon = formatProtocol(response.data);
        this.onSubmit();
      }
    }
  }, {
    key: "cancelUpload",
    value: function cancelUpload() {
      this.$refs.upload.abort(this.file);
      this.file = null;
      this.loadingIcon = false;
    }
  }, {
    key: "onSubmit",
    value: function onSubmit() {
      var _this6 = this;

      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this6.cancelUpload();

          var params = {
            id: _this6.userForm.id,
            phoneNo: _this6.userForm.phoneNo,
            userIcon: _this6.userForm.userIcon,
            email: _this6.userForm.email,
            reallyName: _this6.userForm.reallyName,
            address: _this6.userForm.address,
            province: _this6.userForm.province,
            city: _this6.userForm.city,
            provinceName: _this6.userForm.provinceName,
            cityName: _this6.userForm.cityName,
            county: _this6.userForm.county,
            countyName: _this6.userForm.countyName
          };
          apis.setUserInfo(params).then(function (res) {
            _this6.$message.success('保存成功');

            _this6.submitReset();

            _this6.getUserInfo();
          }).catch(function (_) {
            _this6.$message.error('保存失败');
          });
        }
      });
    } // 更新按钮状态

  }, {
    key: "submitReset",
    value: function submitReset() {
      this.isChangeName = false;
      this.isChangeEmail = false;
      this.isChangeAddress = false;
    } // 将省市县的编码加上code

  }, {
    key: "formatAncestorGbCode",
    value: function formatAncestorGbCode(list, type) {
      var gbCode = this.getAncestorGbCode(type);
      list.forEach(function (item, index) {
        list[index].gbCode = "".concat(gbCode).concat(item.gbCode);
      });
      return list;
    }
  }, {
    key: "getAncestorGbCode",
    value: function getAncestorGbCode(type) {
      var gbCode = '';

      switch (type) {
        case 'province':
          gbCode += "".concat(this.provinceCode, ".");
          break;

        case 'city':
          gbCode += "".concat(this.userForm.province, ".");
          break;

        case 'count':
          gbCode += "".concat(this.userForm.city, ".");
          break;

        default:
          break;
      }

      return gbCode;
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.$store.dispatch('DEL_MENU');
      this.getUserInfo();
    }
  }, {
    key: "title",
    get: function get() {
      return this.$store.getters.userInfo.title || '';
    }
  }, {
    key: "uploadHeaders",
    get: function get() {
      return uploadConfigIns.headers;
    }
  }]);

  return PersonInfo;
}(Vue);

__decorate([Ref('approveDialog')], PersonInfo.prototype, "approveDialog", void 0);

PersonInfo = __decorate([Component({
  components: {
    BreadcrumbHeader: BreadcrumbHeader,
    PasswordReset: PasswordReset,
    ApproveDialog: ApproveDialog
  }
})], PersonInfo);
export default PersonInfo;